import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { HomeScreen } from "../screens/HomeScreen";
import { ActivitiesScreen } from "../screens/ActivitiesScreen";
import StudioScreen from "../screens/StudioScreen";
import ParentScreen from "../screens/ParentScreen";
import { NewProjectPermissionRoute, PermissionRoute } from "../parent/PermissionRoute";

const NewProjectScreen = lazy(async () => import("../screens/NewProjectScreen"));

function ScreenLoader() {
  return (
    <main className="screen-loader" aria-live="polite">
      <span className="spinner" aria-hidden="true" />
      <p>Getting your art space ready…</p>
    </main>
  );
}

export function AppRoutes() {
  return (
    <Suspense fallback={<ScreenLoader />}>
      <Routes>
        <Route path="/" element={<HomeScreen />} />
        <Route
          path="/activities"
          element={
            <PermissionRoute capability="useActivities">
              <ActivitiesScreen />
            </PermissionRoute>
          }
        />
        <Route
          path="/new"
          element={
            <NewProjectPermissionRoute>
              <NewProjectScreen />
            </NewProjectPermissionRoute>
          }
        />
        <Route path="/parent" element={<ParentScreen />} />
        <Route path="/studio/:projectId" element={<StudioScreen />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
}
